import { render, staticRenderFns } from "./ProBadge.vue?vue&type=template&id=6bd5a531"
import script from "./ProBadge.vue?vue&type=script&lang=js"
export * from "./ProBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports